import { BenefitStats, CompanyBenefitStats } from '@pxtra-client-lib-legacy/gen';
import { LoadingProps } from '../../partials/basePage';
import './scrollableList';

const ICON_STYLES = {
  color: 'common.white',
  backgroundColor: 'heaven.main',
  borderRadius: '0.75rem'
};

export const ICON_PROPS = {
  size: 48,
  sx: ICON_STYLES
};

export type BenefitItemProps = BenefitStats & {
  key: keyof Omit<CompanyBenefitStats, 'employee_count'>;
};

export type BenefitWishesActiveDashboardWidgetProps = {
  stats: Array<BenefitItemProps>;
  employeeCount?: CompanyBenefitStats['employee_count'];
} & LoadingProps;
